import React from "react";
import { Formik, Field, Form } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

/**
 * Formulário de filtros específico para o relatório de Contas a Pagar.
 * Campos: Ordenar, Centro de Custo, Pessoas, Vencimento Inicial/Final.
 * 
 * NOTA: Este relatório NÃO possui os campos de Moeda, Situação, Grupo de Clientes,
 * Banco, PDFs Separados ou "Enviada há (dias)".
 */
export default function FormContasPagar({
  // Opções dos dropdowns
  porOptions,
  pessoasOptions,

  // Valores atuais do estado
  por,
  clientes,
  vencimentoInicial,
  vencimentoFinal,

  // Textos de busca para filtragem nos Selects
  pessoasOptionsTexto,

  // Handlers de mudança de estado
  onPorChange,
  onPessoasChange,
  onRemoverPessoa,
  onVencimentoInicialChange,
  onVencimentoFinalChange,

  // Handlers de busca (onInputChange dos Selects)
  onPessoasInputChange,

  // Dados complementares
  pessoas,        // Array completo de pessoas (para exibir nome ao remover)
  filterSearch,   // Função de filtro reutilizável

  // Submissão
  onSubmit,
  validForm,
}) {
  return (
    <Formik
      initialValues={{ name: "" }}
      onSubmit={async () => {
        await new Promise((r) => setTimeout(r, 1000));
        onSubmit();
      }}
    >
      <Form className="contact-form">
        <div className="row">
          <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"></div>
          <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
            <div className="row addservicos">

              {/* Ordenar */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm firstLabel">
                <label>Ordenar:</label>
              </div>
              <div className="col-1 errorMessage">
                {!por && <FontAwesomeIcon title="Preencha o campo" icon={faExclamationTriangle} />}
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Select
                  className="SearchSelect"
                  options={porOptions}
                  value={porOptions.find((o) => o.value == por)}
                  search={true}
                  onChange={(e) => onPorChange(e.value)}
                />
              </div>

              {/* Pessoas (multi-seleção) */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Pessoas</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Select
                  className="SearchSelect"
                  options={pessoasOptions
                    .filter((e) => filterSearch(e, pessoasOptionsTexto))
                    .slice(0, 20)}
                  onInputChange={(e) => onPessoasInputChange(e)}
                  search={true}
                  onChange={(e) => onPessoasChange(e.value)}
                />
                <div style={{ marginBottom: 0, color: "white", fontSize: 13 }}>
                  {clientes.map((clienteId, i) => (
                    <span
                      key={clienteId}
                      className="click_to_erase"
                      onClick={() => onRemoverPessoa(clienteId)}
                    >
                      {`${pessoas.find((p) => p.Chave == clienteId)?.Nome || clienteId}${i != clientes.length - 1 ? ", " : " "}`}
                    </span>
                  ))}
                </div>
              </div>

              {/* Espaçador visual antes dos campos de data */}
              <div style={{ marginTop: 20 }}></div>

              {/* Vencimento Inicial */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Vencimento Inicial</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Field
                  className="form-control"
                  type="date"
                  value={vencimentoInicial}
                  onChange={(e) => onVencimentoInicialChange(e.target.value)}
                />
              </div>

              {/* Vencimento Final */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Vencimento Final</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Field
                  className="form-control"
                  type="date"
                  value={vencimentoFinal}
                  onChange={(e) => onVencimentoFinalChange(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1"></div>
        </div>

        {/* Botão Gerar */}
        <div className="row">
          <div className="col-2"></div>
          <div className="col-8" style={{ display: "flex", justifyContent: "center" }}>
            <button
              disabled={!validForm}
              type="submit"
              style={validForm ? { width: 300 } : { backgroundColor: "#eee", opacity: 0.3, width: 300 }}
            >
              Gerar
            </button>
          </div>
          <div className="col-2"></div>
        </div>
      </Form>
    </Formik>
  );
}